import { trackLinkClick } from "@snowplow/browser-plugin-link-click-tracking";

import { SP_MAIN_TRACKER } from "@src/observability";

// Captured before the secure mode guard replaces it, so sanctioned navigation
// still works while the guard is active.
const nativeOpen = globalThis.open.bind(globalThis);

const HTTP_PROTOCOLS = new Set(["http:", "https:"]);
// Blobs and data URIs are how the career plan PDF reaches the user.
const IN_APP_PROTOCOLS = new Set(["blob:", "data:"]);

export const resolveUrl = (url) => {
  if (!url) {
    return;
  }

  try {
    // Institution web addresses arrive without a scheme. Some of them only
    // load over http, so we cannot assume https.
    return new URL(/^https?:\/\//i.test(url) ? url : `http://${url}`);
  } catch {
    return;
  }
};

export const isExternalHref = (href) => {
  let url;

  try {
    url = new URL(href, globalThis.location.href);
  } catch {
    return false;
  }

  if (IN_APP_PROTOCOLS.has(url.protocol)) {
    return false;
  }

  // mailto: and tel: leave the app as surely as a cross-origin page does.
  return (
    !HTTP_PROTOCOLS.has(url.protocol) ||
    url.origin !== globalThis.location.origin
  );
};

export const openExternalUrl = (url, { label } = {}) => {
  const resolved = resolveUrl(url);

  if (!resolved) {
    return;
  }

  nativeOpen(resolved.href, "_blank", "noreferrer");

  // Snowplow auto-tracks anchor clicks, so only the imperative path reports.
  trackLinkClick({ targetUrl: resolved.href, elementContent: label }, [
    SP_MAIN_TRACKER,
  ]);
};
